// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_cardInput__yMmxS {
  background: transparent;
  border: none;
  outline: none;
  width: 100%;
  overflow: hidden;
  resize: none;
  border-radius: 0.4rem;
  animation: style_pulsing_alert__J75ZC 5s infinite;
}

.style_cardInput__yMmxS:focus {
  animation: none
}

@keyframes style_pulsing_alert__J75ZC {
  0% {
    background-color: transparent;
  }
  30% {
    background-color: transparent;
  }
  40% {
    box-shadow: 0 0 0 0.1rem #dfdce3;
  }
  61% {
    background-color: transparent;
  }
  100% {
    background-color: transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/private/Dashboard/pages/Testimonials/TestimonialsCard/style.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,iDAAoC;AACtC;;AAEA;EACE;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".cardInput {\n  background: transparent;\n  border: none;\n  outline: none;\n  width: 100%;\n  overflow: hidden;\n  resize: none;\n  border-radius: 0.4rem;\n  animation: pulsing_alert 5s infinite;\n}\n\n.cardInput:focus {\n  animation: none\n}\n\n@keyframes pulsing_alert {\n  0% {\n    background-color: transparent;\n  }\n  30% {\n    background-color: transparent;\n  }\n  40% {\n    box-shadow: 0 0 0 0.1rem #dfdce3;\n  }\n  61% {\n    background-color: transparent;\n  }\n  100% {\n    background-color: transparent;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardInput": `style_cardInput__yMmxS`,
	"pulsing_alert": `style_pulsing_alert__J75ZC`
};
export default ___CSS_LOADER_EXPORT___;
